export enum TimeSlots {
  MATIN = 'matin',
  MIDI = 'midi',
  APRES_MIDI = 'apres-midi',
}

export type Hole = 18 | 11 | 9 | 6
